import { render } from "./EducationItem.vue?vue&type=template&id=17bc1696"
import script from "./EducationItem.vue?vue&type=script&lang=js"
export * from "./EducationItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Luke\\Documents\\GitHub\\mclg1.github.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__